import React, { useEffect, useState, forwardRef } from 'react'
import {Dialog, Slide } from '@mui/material'
import { TransitionProps } from '@mui/material/transitions'
import { fireReactGAEvent } from '../Questions/utils'
import TotallyMoneyInterstitialContent from './TotallyMoneyInterstitialContent'
import AutotraderInterstitialContent from './AutotraderInterstitialContent'
import MoneySupermarketInterstitialContent from './MoneySupermarketInterstitialContent'

const dialogStyles = {
  px: 0,
  textAlign: 'center',
  backgroundColor: '#fff',
  opacity: 1,
  boxShadow: 0,
  zIndex: '99999999999', /* Important so that Cookie Pro banner doesn't overlay */
  '.interstitial-header svg': {
    position: 'relative',
    transform: 'scale(0.90)'
  },
  '.MuiPaper-root': {
    margin: '0',
    width: '100%',
    padding: '30px 0',
    boxShadow: 0
  },
  '.MuiDialogContent-root': {
    maxWidth: '360px',
    margin: 'auto'
  }
}

const intEvent = (experiment:string, open:boolean) => {
  fireReactGAEvent({
    category: 'Application Form',
    action: open ? 'Interstitial Started' : 'Interstitial Ended',
    label: experiment
  })
}

const Transition = forwardRef((
  props: TransitionProps & {
    children: React.ReactElement<any, any>,
  },
  ref: React.Ref<unknown>
) => <Slide unmountOnExit direction="right" ref={ref} {...props} />)

type InterstitialProps = {
  experimentName: string,
  source: string
}

const isMsm = (source: string): boolean => source === 'msm' || source === 'moneysupermarket'

const InterstitialWrapper = ({ experimentName, source }: InterstitialProps): JSX.Element => {
  const [open, setOpen] = useState(false)

  useEffect(() => {
    setOpen(true)
    intEvent(experimentName, true)
  }, [])

  useEffect(() => {
    const interstitialCloseTime = isMsm(source) ? 6000 : 4000
    if (open) {
      setTimeout(() => {
        setOpen(false)
        intEvent(experimentName, false)
      }, interstitialCloseTime)
    }
  }, [open])

  const renderDialogContent = (source: string): JSX.Element => {
    switch(source) {
      case 'autotrader': 
        return ( <AutotraderInterstitialContent /> )
      case 'totallymoney': 
        return ( <TotallyMoneyInterstitialContent /> )
      case 'moneysupermarket':
      case 'msm':
        return ( <MoneySupermarketInterstitialContent /> )
      default: 
        return ( <></> )
    } 
  }

  return (
    <Dialog
      open={open}
      data-testid={`${source}-interstitial`}
      TransitionComponent={Transition}
      keepMounted={false}
      aria-describedby="Let's check your eligibility"
      sx={dialogStyles}
      slotProps={{ backdrop: { style: { backgroundColor: 'rgba(255,255,255,1)' } } }}
      fullScreen
      fullWidth
    >
      {renderDialogContent(source)}
    </Dialog>
  )
}

export default InterstitialWrapper
